export default __webpack_public_path__ + "static/Face5-4b5dcfcb49717f343790c11706f0903f.jpg";